// Tooltip.tsx
import React from "react";
import { View, Text, StyleSheet, Image, ScrollView } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppImages } from "../../utility/AppImages";
import { TouchableOpacity } from "react-native-gesture-handler";
import { AppFontStyle } from "../../styles/AppFontStyle";

type ProfileTooltipProps = {
  content: any;
  visible: boolean;
  setVisible?: any;
  width?: any;
  right?: number;
  boxViewStyle?: any;
  closeBtnMargin?: number;
  closeImage?: any;
  bottom?: number;
  tooltipStyle?: any;
};

const ProfileTooltip: React.FC<ProfileTooltipProps> = ({
  content,
  visible,
  setVisible,
  width = "auto",
  right = 20,
  boxViewStyle = {},
  closeBtnMargin = 10,
  bottom = -50,
  closeImage = AppImages.icCloseWhiteSvg,
  tooltipStyle,
}) => {
  if (!visible) return null;

  return (
    <View
      style={[
        styles.tooltipContainer,
        tooltipStyle,
        {
          width: width,
          right: right,
          bottom: bottom,
          zIndex: 2000,
        },
      ]}
    >
      <View style={styles.tooltip}>
        <Text style={styles.tooltipText}>{content}</Text>
        <TouchableOpacity
          onPress={() => {
            setVisible(false);
          }}
          style={{ alignItems: "flex-end" }}
        >
          <Image
            source={closeImage}
            style={{
              height: 16,
              width: 16,
              marginBottom: closeBtnMargin,
            }}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  tooltipContainer: {
    position: "absolute",
    bottom: 30,
    zIndex: 1000,
    alignItems: "center",
  },
  tooltip: {
    padding: 12,
    borderRadius: 12,
    backgroundColor: AppColors.black_060506,
    flexDirection: "row",
    gap: 16,
  },
  tooltipText: {
    color: "white",
    ...AppFontStyle.MEDIUM_ANYBODY_16,
  },
});

export default ProfileTooltip;
